export class SelfassessmentKeyInformation {
  id: number;
  rulebookRuleID: string;
  ruleOwner: string;
  complianceStatus: string;
  assessmentDate: Date;
  reviewDate: Date;
  assessmentStatus: string;
  lbgImpact: boolean;
  rfbImpact: boolean;
  lbcmImpact: boolean;
  nextAssessmentDueDate: Date;
  summaryDetailsId: number;

  constructor() {
    this.id = 0;
    this.rulebookRuleID = '';
    this.ruleOwner = '';
    this.complianceStatus = '';
    this.assessmentDate = new Date();
    this.reviewDate = new Date();
    this.assessmentStatus = '';
    this.lbgImpact = false;
    this.rfbImpact = false;
    this.lbcmImpact =false;
    this.nextAssessmentDueDate = new Date();
    this.summaryDetailsId = 0;
  }
}
export interface SelfAssessmentT3KeyInformationSummaryDto {
  id: number;
  summaryDetailsId: number;
  referenceNumber: string;
  title: string;
  topic: string;
  reviewStatus: string;
  reviewClassStyle: string;
  reviewIcon: string;
  approvers: string;
  confirmApproval: string;
  approverDate: Date | null;
  nextApprovalDue: Date | null;
  lbgMateriality: string;
  lbgClassStyle: string;
  lbgIcon: string;
  rfbMateriality: string;
  rfbClassStyle: string;
  rfbIcon: string;
  lbcmMateriality: string;
  lbcmClassStyle: string;
  lbcmIcon: string;
  type: string;
  orderBy: number;
}
